import React, { createContext, useReducer } from 'react';
import initialState from "./initial-state";

// Create a context for the store
export const StoreContext = createContext(initialState);

// Create a Provider HOC for the store
export const StoreProvider = ({ reducer, initialState, children }) => {
    return (
        <StoreContext.Provider
            value={useReducer(reducer, initialState)}
            children={children}
        />
    );
}
